import React from 'react';

import PropTypes from 'prop-types';
import { t } from '@lingui/macro';

import { Button, Flex, TextField } from '@decisiv/ui-components';
import MinusCircle from '@decisiv/iconix/lib/components/MinusCircle';
import PlusCircle from '@decisiv/iconix/lib/components/PlusCircle';
import { isEmpty } from 'lodash';

export default function EditMetadata({
  metadata,
  handlers,
  editDisabled = true,
  errorsArray = {},
}) {
  const shouldShowCharCount = (errorAttribute) => isEmpty(errorAttribute);

  return (
    <>
      {metadata.map((item, index) => (
        <Flex
          key={item.rowId}
          justifyContent="flex-start"
          alignItems="center"
          style={{
            whiteSpace: 'nowrap',
            gap: '1.25rem',
            margin: '-1px',
            border: '1px solid var(--if-border)',
            padding: '0.625rem',
          }}
        >
          <Button
            aria-label={t`Remove entry`}
            variant="ghost"
            icon={MinusCircle}
            disabled={editDisabled}
            onClick={() => handlers.removeEntry(index)}
          />
          <TextField
            required
            value={item.key}
            label={t`key`}
            name={`metadata-key-${index}`}
            style={{ marginTop: '0.5rem' }}
            maxLength={50}
            disabled={editDisabled}
            showCharacterCount={shouldShowCharCount(
              errorsArray[`metadata-key-${index}`],
            )}
            warningMessage={errorsArray[`metadata-key-${index}`]}
            onChange={(e) => handlers.changeKey({ e, item, index })}
          />
          <TextField
            required
            value={item.value}
            label={t`value`}
            name={`metadata-value-${index}`}
            style={{ marginTop: '0.5rem' }}
            maxLength={500}
            disabled={editDisabled}
            showCharacterCount={shouldShowCharCount(
              errorsArray[`metadata-value-${index}`],
            )}
            warningMessage={errorsArray[`metadata-value-${index}`]}
            onChange={(e) => handlers.changeValue({ e, item, index })}
          />
        </Flex>
      ))}
      <Flex
        justifyContent="flex-start"
        alignItems="center"
        style={{
          border: '1px solid var(--if-border)',
          margin: '-1px',
          gap: '1.25rem',
          padding: '0.625rem',
        }}
      >
        <Button
          aria-label={t`Add Metadata`}
          text={t`Add Metadata`}
          icon={PlusCircle}
          variant="ghost"
          disabled={editDisabled || metadata[metadata.length - 1]?.key === ''}
          onClick={handlers.addEntry}
        />
      </Flex>
    </>
  );
}

EditMetadata.propTypes = {
  metadata: PropTypes.arrayOf(
    PropTypes.shape({
      rowId: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handlers: PropTypes.shape({
    addEntry: PropTypes.func.isRequired,
    removeEntry: PropTypes.func.isRequired,
    changeKey: PropTypes.func.isRequired,
    changeValue: PropTypes.func.isRequired,
  }).isRequired,
  editDisabled: PropTypes.bool,
  errorsArray: PropTypes.objectOf(PropTypes.string),
};
